import { Box, Card, CardContent, Chip, Divider, FormControl, FormControlLabel, Grid, Paper, Radio, RadioGroup, Stack, Tooltip, Typography } from "@mui/material";
import { format } from "date-fns";
import { useSnackbar } from "notistack";
import { useCallback, useEffect, useState } from "react";
import { getVendorExpenses } from "services/vendorDashboard";
import { getDbFormat } from "utils/common";
import CurrencyRupeeRoundedIcon from '@mui/icons-material/CurrencyRupeeRounded';
import DateRangeRoundedIcon from '@mui/icons-material/DateRangeRounded';
import { grey, indigo, red } from "@mui/material/colors";

export default function VendorExpenses({pageFilters}) {
  
  const { enqueueSnackbar } = useSnackbar();
  const [expenses, setExpenses] = useState(null);

  const getExpenses = useCallback((pageFilters) => {
    const [from, to ]= pageFilters.filterDates;
    const data = {
      from: getDbFormat(from), to: getDbFormat(to), propertyId: pageFilters.library.id, propertyType: 'LIBRARY'
    };
    getVendorExpenses(data).then(({response, error}) => {
      if(response){
        setExpenses(response);
      } else {
        setExpenses([]);
        enqueueSnackbar((response?.message || error), {variant: 'error'});
      }
    });
  }, [enqueueSnackbar]);
  
  useEffect(() => {
    if(pageFilters){
      getExpenses(pageFilters);
    }
  }, [getExpenses, pageFilters]);
  
  return (
    <Paper sx={{ minWidth: 275, py: 2, px: 2, minHeight: "calc(100vh - 100px )" }} elevation={0}>
     
      <Box noValidate>
        <Grid container columnSpacing={4} rowSpacing={2} >
          {(expenses || []).map((expense, index) => (
            <Grid item xs={10} sm={6} md={6} xl={3} lg={4} key={index} >
              <Card sx={{  position: 'relative',  height: '100%', backgroundColor: grey[50]}} >
                <CardContent>
                  <Stack direction="row" alignItems="center" justifyContent="space-between">
                    <Stack direction="row" alignItems="center">
                      <CurrencyRupeeRoundedIcon sx={{color: red[400]}} />
                      <Typography  variant="h5" fontSize={26} component="div" sx={{color: red[400]}}>
                        {expense.amount}
                      </Typography>
                    </Stack>
                    <Stack direction="row" alignItems="center">
                      <DateRangeRoundedIcon sx={{fontSize: 16, color: indigo[400]}} />
                      <Typography  variant="body2" component="div" sx={{color: indigo[400]}}>
                        &nbsp;{expense?.createdOn ? format(new Date(expense.createdOn), 'dd-MM-yyyy') : null}
                      </Typography>
                    </Stack>
                  </Stack>
                  <Typography gutterBottom variant="body1" component="div" >
                    {expense.type}  
                  </Typography>
                 
                  <Tooltip title={expense?.comments}>

                    <Typography gutterBottom variant="caption"  color="text.secondary" noWrap>
                      {expense?.comments}
                    </Typography>
                  </Tooltip>

                </CardContent>
              </Card>
            </Grid>
          ))}
          {expenses?.length === 0 ? (
            <Typography color="error" variant="h5" component="h5"> No data found</Typography>
          ): null}
        </Grid>
      </Box>
    </Paper>
  );
}
